import styled from "styled-components";

import {
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_BORDER_LIGHT_GREY,
	COLOR_WHITE,
	COLOR_RB_PURPLE_300,
	COLOR_RB_PURPLE_200,
	COLOR_NAVIGATION_GREY,
	MOBILE_L_BP,
	DESKTOP_SM_BP,
	TABLET_BP,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	align-items: center;
	padding: 45px 0px 0px 0px;
	.my-masonry-grid {
		display: flex !important;
		margin: 0px 30px;
		align-items: flex-start;
		width: auto;
	}
	.my-masonry-grid_column {
		margin: 10px;
		width: 100%;
	}

	/* Style your items */
	.my-masonry-grid_column > div {
		/* change div to reference your elements you put in <Masonry> */
		margin-bottom: 30px;
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 45px 0px;
	}
	.reviews-card {
		margin: 10px;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
	}
`;
export const FilterDropdown = styled.div`
	margin: 30px auto;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		width: 90%;
		display: block;
	}
	display: none;
`;

export const AlumniContainer = styled.div`
	display: flex;
`;

export const CardsContainer = styled.div`
	width: 60%;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		width: 100%;
		margin: auto;
	}
`;
export const FilterNav = styled.div`
	margin: 56px;
	ul {
		display: flex;
		list-style: none;
		justify-content: space-between;
		cursor: pointer;
		li {
			padding: 15px 20px;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			font-size: 18px;
			font-weight: ${FONT_WT_MEDIUM};
		}
	}
	.checked {
		background: ${COLOR_BORDER_LIGHT_GREY};
		border-radius: 3px;
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		display: none;
	}
`;

export const Cards = styled.div`
	.slick-initialized .slick-slide {
		> div {
			margin: 0px 50px;
			display: flex;
			flex-basis: 90%;
			flex-wrap: wrap;
			justify-content: center;
			align-items: flex-start;
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) and (min-width: ${TABLET_BP}px) {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}

	.slick-prev {
		display: none !important;
	}
	button.slick-next {
		position: relative;
		margin: 10px 0px 20px 0px;
		top: 10px;
		left: 49%;
		cursor: pointer;
		background-color: ${COLOR_WHITE};
		background-image: url(https://res.cloudinary.com/springboard-images/image/upload/v1549599728/homepage-assets/icons/gun-arrow-right.svg);
		background-repeat: no-repeat;
		background-position: center;
		border-radius: 50%;
		height: 36px;
		width: 36px;
		box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
	}
`;

export const Title = styled.div`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 28px;
	line-height: 33px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	text-align: center;
	margin: 0px 24px;
`;

export const EmailWrapper = styled.div`
  background: ${(props) => props.backgroundColor};
  min-height: 228px;
  display: flex;
  justify-content: center;
  align-items: center;

  .start-application-form {
    justify-content: flex-start;
    button {
      background-color: ${COLOR_RB_PURPLE_300};
      border: 2px solid ${COLOR_RB_PURPLE_300};
    }
    button:hover {
      background-color: ${COLOR_RB_PURPLE_200};
      border-color:  ${COLOR_RB_PURPLE_200};
      color: ${COLOR_WHITE};
    }
  }
    .formGroup.formGroupEmail {
      width: 280px;
    }
  }

  @media only screen and (max-width: ${DESKTOP_SM_BP}px) {
    flex-direction: column;

    .start-application-form {
      justify-content: center;
      .formGroup.formGroupEmail {
        width: 300px;
      }
    }
  }

  @media only screen and (max-width: ${MOBILE_L_BP}px) {
    .start-application-form {
      margin: 0 10px 45px 10px;
      .formGroup.formGroupEmail {
        width: 100%;
      }
    }
  }
`;
export const Header = styled.h2`
	color: ${COLOR_TEXT_PRIMARY_B2C};
	font-size: 24px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 28px;
	margin-right: 30px;

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		margin-right: 0px;
	}
`;

export const LoadMoreButton = styled.div`
	flex-basis: 100%;
	font-size: 17px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	text-align: center;
	margin: 15px 0px;
	.loadMore {
		cursor: pointer;
	}
`;
